import { Component, input } from '@angular/core';
import { AccordionModule } from 'primeng/accordion';

@Component({
  selector: 'app-expansion-panel',
  template: `
    <p-accordion-panel [value]="value()">
      <p-accordion-header>{{ title() }}</p-accordion-header>
      <p-accordion-content>
        <ng-content></ng-content>
      </p-accordion-content>
    </p-accordion-panel>
  `,
  styles: [`
    p-accordion-header {
      background: var(--p-surface-0, #f8f9fa) !important;
      padding: 1.25rem;
      border: 1px solid var(--p-content-border-color, #dee2e6) !important;
      border-radius: 6px !important;
      color: inherit;
    }
    p-accordion-content {
      background: var(--p-surface-0, #ffffff) !important;
      border: 1px solid var(--p-content-border-color, #dee2e6) !important;
      border-top: none !important;
      color: inherit;
    }
    :host-context(.p-dark) p-accordion-header {
      background: #0f0f10 !important;
      border-color: #3f3f46 !important;
      color: #e5e7eb !important;
    }
    :host-context(.p-dark) p-accordion-content {
      background: #0f0f10 !important;
      border-color: #3f3f46 !important;
      color: #e5e7eb !important;
    }
  `],
  standalone: true,
  imports: [AccordionModule],
})
export class ExpansionPanelComponent {
  title = input('');
  value = input('0');
}
